import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UrlPrefix } from "../constants/url-prefix.constants";

@Injectable()
export class TenantSettings {
  public unitOfMeasurement: string;
  public defaultCountry: string;
  public defaultDictionary: number;
  public hideObsoleteFeatures: boolean;
  public isInit: boolean;
  public displayTableForSimpleProductRules: boolean;
  public defaultManagingParentId?: number;
  public defaultOrderingParentId?: number;
  public allowedImageExtensions: Array<string>;
  public allowedProductConfigurationExtensions: Array<string>;
  public allowedContentFileExtensions: Array<string>;
  public allowedFontExtensions: Array<string>;
  public segregationSettingsApplied: boolean;
  public isErpConnected: boolean;
  public useRecurringPrice: boolean;
  public useDealStructure: boolean;
  public canAddEditChangeSet: boolean;
  public canSetPurposeOnCertificate : boolean;
  public isEditingRightPreferred: boolean;
  public cpiNumberOfDecimalPlaces: number;
  public autocompleteMaxSearchColumns: number;
  public autocompleteMaxDisplayColumns: number;
  public showOnlyActiveProducts: boolean;
  public passwordExpirationDays: number;
  public passwordValidationExpression: string;
  public passwordRulesMessage: string;
  public pricebookAuditTrailStatus: PricebookAuditTrailStatusOptions;
  public useNewQuoteEngine: boolean;
  public availableTemporaryPassword: boolean;
  public isSapSBEnabled: boolean;
  public isCpsConnected: boolean;
  public isBrimConnected: boolean;
  public isSolutionOrderConnected: boolean;  
  public isCXAIVisible: boolean;
  public defaultBillingCycleAttributeSystemId: string;
  public defaultContractDurationAttributeSystemId: string;
  public defaultContractExtensionPeriodAttributeSystemId: string;
  public useBusinessPartnerConcept: boolean;
  public showCustomPricingRecurringPeriodFields: boolean;
  public isBusinessPartnersEnabled: boolean;
  public useNewConfiguratorConflicts: boolean;
  public useTwoLetterAbbreviation: boolean;
  public isCPSDocumentPricingUsed: boolean;
  public useCPSAsPricingEngineForQuoteTotalFields: boolean;
  public useFormulaForConditionDetermination: boolean;
  public defaultServiceProfileAttributeSystemId: string;
  public defaultResponseProfileAttributeSystemId: string;
  public defaultServiceContractDurationAttributeSystemId: string;
  public defaultSettlementPeriodAttributeSystemId: string;
  public defaultBillingDateAttributeSystemId: string;
  public isSapCpsLogTokenRequestsEnabled: boolean;
  public showEffectiveDates4PricebookEntries: boolean;
  public maxFileSizeForUpload: number;
  public hideEpaymentFormCustomization: boolean;
  public docuSignConsentEndpoint: boolean;
  public useGlobalUserIdAsFederationIdentifier: boolean;
  public showSBIntegration: boolean;
  public defaultMarketId: number;
  public tenantUrl: string;
  public vsCodeScriptingExtensionUrl: string;
  public tmpAllowVCProductsAsAttributeValues: boolean;
  public scriptExecutionLimitForWarningInSeconds: number;
  public scriptExecutionLimitForErrorInSeconds: number;
  public tmpAllowProductsAsAttributeValues: boolean;
  public isC4CObsoleteIntegrationActive: boolean;
  public showCommerceIntegration: boolean;
  public isCloudIntegrationEnabled: boolean;
  public isCloudForCustomerEnabled: boolean;
  public isCommerceCloudEnabled: boolean;
  public isAdobeSignEnabled: boolean;
  public isDocuSignEnabled: boolean;
  public isExternalConfigurationEnabled: boolean;
  public isEnablementEnabled: boolean;
  public yearBoundary: number;
  public tmpEnableQuoteVisibilityQuery: boolean;
  public enableConditionDelete: boolean;
  public useTimeZonePerTenant : boolean;
  public useCustomerLanguage: boolean;
  public translateQuoteInUsersDefaultDictionary: boolean;
  public generatedFilenamePrefix: string;
  public generatedFilenameSuffix: string;
  public isShareDocumentCustomizations: boolean;
  public genDocOutputFormat: number;
  public importFormatMode: string;
  public breaksToBeUsed: string;
  public userCanSeePreviousDocuments: boolean;
  public shouldUsersDownloadDocumentsWithNoTemplate: boolean;
  public shouldDisableDeletionOfGeneratedDocumentsOnQuote: boolean;
  public shouldHideItemsWithNoFilesOnDocumentGeneration: boolean;
  public shouldReconfigureProductsDuringDocumentGeneration: boolean;
  public shouldUsersDownloadDocumentPrior2012JanuaryRelease: boolean;
  public forbidSavingInvalidResponsiveTemplates: boolean;
  public salesTaxBusinessPartnerFunction: string;
  public relationshipBusinessPartnerFunction: string;
  public minimumAllowedPasswordLength: number;
  public maximumAllowedPasswordLength: number;
  public minimumAllowedNumberOfPasswordsInHistoryToCheck: number;
  public maximumAllowedNumberOfPasswordsInHistoryToCheck: number;
  public useNewDocumentGenerationPage: boolean;
  public isCompanionEnabled: boolean;
  public tmpSapCompanionFunctionality: boolean;
  public arePromotionsEnabled: boolean;
  public isEnabledConfigurationWithoutQuote: boolean;
  public hideSimpleProductSegregation: boolean;
  public useSalesUnitOfMeasure: boolean;
  public tmpAllowAttributeTriggersForVCProducts: boolean;
  public useScaledPricing: boolean;
  public tmpMigrationToQuote2: boolean;
  public allowGenerateDocumentForMultiSectionTemplate: boolean;
  public sourceMigrationTenant: string;
  public useUsageBasedPricing: boolean;
  public triggerSaveAction: boolean;
  public isMultiLicenseConceptEnabled: boolean;
  public localAdminCanShowCost: boolean;
  public userCanAttachGenDocOptions: string;
  public doNotPreselectTOOnSendMail: boolean;
  public doNotPreselectCcOrBccEmailAddresses: boolean;
  public hideSendMailAfterGenDoc: boolean;
  public hideEmailFormFromGenDoc: boolean;
  public hideSendDocumentToOpportunity: boolean;
  public attachDocumentToCRMWhenSendingEmail: boolean;
  public emailsSentBy: string;
  public predefinedEmailClient: string;
  public predefinedEmailBodyType: string;
  public emailSubject: string;
  public emailBody: string;
  public areEmailFromAndNameFieldsDisabled: boolean;
  public useMarketFromQuote: boolean;
  public showBusinessPartnerSensitiveFields: boolean;
  public defaultCalculationEnabled: boolean;
  public salesAreaEnabled: boolean;
  public salesAreaInMigrationMode: boolean;
  public approvalsAutoReminderTestMode: boolean;
  public isNewReportModuleEnabled: boolean;
  public tmpEnableLegacyFederationEndpoints: boolean;
  public isQuoteMigrationFeatureEnabled: boolean;
  public tmpAllowCopyingBackOfficeProducts: boolean;
  public isEuDpEnvironment: boolean;
  public tmpUseOldEventLogPage: boolean;
  public tmpUseGetEventLogsWithTotalCount: boolean;
  public enablePdfCompression: boolean;
  public imageCompressionType: number;
  public imageJpegQuality: number;
  public downsampleImagesResolution: number;
  public downsampleImagesResolutionThreshold: number;
  public productCustomFieldsEnabled: boolean;
  public tmpDisableQtAttributePlaceholders: boolean;
  public allowLegacySmtpType: boolean;
  public tenantID: string;
  public builtInSupportURLPath: string;
  public builtInSupportCSSURLPath: string;
  public builtInSupportTargetEnvironment: string;
  public tmpSapBuiltInSupportFunctionality: string;
  public allowedAdditionalFileExtensions: Array<string>;
  public tmpEnableDkimSha1CertificateGeneration: boolean;
  public preselectedLanguageFormula: string;
  public tmpIsSolutionOrderDirectIntegrationEnabled: boolean;
  public isJouleIntegrationEnabled: boolean;
  public jouleTenantUrl: string;
  public jouleDigitalAssistantName: string;

  public get isSalesAreaVisible(): boolean {
    return this.salesAreaEnabled || this.salesAreaInMigrationMode;
  }

  constructor (private http: HttpClient) {
  }

  public init() {
    return this.http
        .get<any>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/tenant`)
        .toPromise()
        .then(tenant => {
          this.unitOfMeasurement = tenant.unitOfMeasurement;
          this.defaultCountry = tenant.defaultCountry;
          this.defaultDictionary = tenant.defaultDictionary;
          this.hideObsoleteFeatures = tenant.hideObsoleteFeatures;
          this.displayTableForSimpleProductRules = tenant.displayTableForSimpleProductRules;
          this.defaultManagingParentId = tenant.defaultManagingParentId;
          this.defaultOrderingParentId = tenant.defaultOrderingParentId;
          this.allowedImageExtensions = tenant.allowedImageExtensions;
          this.allowedProductConfigurationExtensions = tenant.allowedProductConfigurationExtensions;
          this.allowedContentFileExtensions = tenant.allowedContentFileExtensions;
          this.allowedFontExtensions = tenant.allowedFontExtensions;
          this.segregationSettingsApplied = tenant.segregationSettingsApplied;
          this.isErpConnected = tenant.isErpConnected;
          this.useRecurringPrice = tenant.useRecurringPrice;
          this.useDealStructure = tenant.useDealStructure;
          this.canAddEditChangeSet = tenant.canAddEditChangeSet;
          this.canSetPurposeOnCertificate = tenant.canSetPurposeOnCertificate;
          this.isEditingRightPreferred = tenant.isEditingRightPreferred;
          this.cpiNumberOfDecimalPlaces = tenant.cpiNumberOfDecimalPlaces;
          this.autocompleteMaxSearchColumns = tenant.autocompleteMaxSearchColumns;
          this.autocompleteMaxDisplayColumns = tenant.autocompleteMaxDisplayColumns;
          this.showOnlyActiveProducts = tenant.showOnlyActiveProducts;
          this.passwordExpirationDays = tenant.passwordExpirationDays;
          this.passwordValidationExpression = tenant.passwordValidationExpression;
          this.passwordRulesMessage = tenant.passwordRulesMessage;
          this.pricebookAuditTrailStatus = tenant.pricebookAuditTrailStatus;
          this.useNewQuoteEngine = tenant.useNewQuoteEngine;
          this.availableTemporaryPassword = tenant.availableTemporaryPassword;
          this.isSapSBEnabled = tenant.isSapSBEnabled;
          this.isCpsConnected = tenant.isCpsConnected;
          this.isBrimConnected = tenant.isBrimConnected;
          this.isSolutionOrderConnected = tenant.isSolutionOrderConnected;
          this.isCXAIVisible = tenant.isCXAIVisible;
          this.defaultBillingCycleAttributeSystemId = tenant.defaultBillingCycleAttributeSystemId;
          this.defaultContractDurationAttributeSystemId = tenant.defaultContractDurationAttributeSystemId;
          this.defaultContractExtensionPeriodAttributeSystemId = tenant.defaultContractExtensionPeriodAttributeSystemId;
          this.showCustomPricingRecurringPeriodFields = tenant.showCustomPricingRecurringPeriodFields;
          this.useBusinessPartnerConcept = tenant.useBusinessPartnerConcept;
          this.isBusinessPartnersEnabled = tenant.isBusinessPartnersEnabled;
          this.useNewConfiguratorConflicts = tenant.useNewConfiguratorConflicts;
          this.useTwoLetterAbbreviation = tenant.useTwoLetterAbbreviation;
          this.isCPSDocumentPricingUsed = tenant.isCPSDocumentPricingUsed;
          this.useCPSAsPricingEngineForQuoteTotalFields = tenant.useCPSAsPricingEngineForQuoteTotalFields;
          this.useFormulaForConditionDetermination=tenant.useFormulaForConditionDetermination;
          this.defaultServiceProfileAttributeSystemId = tenant.defaultServiceProfileAttributeSystemId;
          this.defaultResponseProfileAttributeSystemId = tenant.defaultResponseProfileAttributeSystemId;
          this.defaultServiceContractDurationAttributeSystemId = tenant.defaultServiceContractDurationAttributeSystemId;
          this.defaultSettlementPeriodAttributeSystemId = tenant.defaultSettlementPeriodAttributeSystemId;
          this.defaultBillingDateAttributeSystemId = tenant.defaultBillingDateAttributeSystemId;
          this.isSapCpsLogTokenRequestsEnabled = tenant.isSapCpsLogTokenRequestsEnabled;
          this.showEffectiveDates4PricebookEntries = tenant.showEffectiveDates4PricebookEntries;
          this.maxFileSizeForUpload = tenant.maxFileSizeForUpload;
          this.hideEpaymentFormCustomization = tenant.hideEpaymentFormCustomization;
          this.docuSignConsentEndpoint = tenant.docuSignConsentEndpoint;
          this.useGlobalUserIdAsFederationIdentifier = tenant.useGlobalUserIdAsFederationIdentifier;
          this.showSBIntegration = tenant.showSBIntegration;
          this.defaultMarketId = tenant.defaultMarketId;
          this.tenantUrl = tenant.tenantUrl;
          this.vsCodeScriptingExtensionUrl = tenant.vsCodeScriptingExtensionUrl
          this.tmpAllowVCProductsAsAttributeValues = tenant.tmpAllowVCProductsAsAttributeValues;
          this.tmpAllowProductsAsAttributeValues = tenant.tmpAllowProductsAsAttributeValues;
          this.isC4CObsoleteIntegrationActive = tenant.isC4CObsoleteIntegrationActive;
          this.showCommerceIntegration = tenant.showCommerceIntegration;
          this.isCloudIntegrationEnabled = tenant.isCloudIntegrationEnabled;
          this.isCloudForCustomerEnabled = tenant.isCloudForCustomerEnabled;
          this.isCommerceCloudEnabled = tenant.isCommerceCloudEnabled;
          this.isAdobeSignEnabled = tenant.isAdobeSignEnabled;
          this.isDocuSignEnabled = tenant.isDocuSignEnabled;
          this.isExternalConfigurationEnabled = tenant.isExternalConfigurationEnabled;
          this.isEnablementEnabled = tenant.isEnablementEnabled;
          this.isInit = true;
          this.scriptExecutionLimitForWarningInSeconds = tenant.scriptExecutionLimitForWarning / 1000;
          this.scriptExecutionLimitForErrorInSeconds = tenant.scriptExecutionLimitForError / 1000;
          this.yearBoundary = tenant.yearBoundary;
          this.tmpEnableQuoteVisibilityQuery = tenant.tmpEnableQuoteVisibilityQuery;
          this.enableConditionDelete = tenant.enableConditionDelete;
          this.useTimeZonePerTenant = tenant.useTimeZonePerMarket;
          this.useCustomerLanguage = tenant.useCustomerLanguage;
          this.translateQuoteInUsersDefaultDictionary = tenant.translateQuoteInUsersDefaultDictionary;
          this.generatedFilenamePrefix = tenant.generatedFilenamePrefix;
          this.generatedFilenameSuffix = tenant.generatedFilenameSuffix;
          this.isShareDocumentCustomizations = tenant.isShareDocumentCustomizations;
          this.genDocOutputFormat = tenant.genDocOutputFormat;
          this.importFormatMode = tenant.importFormatMode;
          this.breaksToBeUsed = tenant.breaksToBeUsed;
          this.userCanSeePreviousDocuments = tenant.userCanSeePreviousDocuments;
          this.shouldUsersDownloadDocumentsWithNoTemplate = tenant.shouldUsersDownloadDocumentsWithNoTemplate;
          this.shouldDisableDeletionOfGeneratedDocumentsOnQuote = tenant.shouldDisableDeletionOfGeneratedDocumentsOnQuote;
          this.shouldHideItemsWithNoFilesOnDocumentGeneration = tenant.shouldHideItemsWithNoFilesOnDocumentGeneration;
          this.shouldReconfigureProductsDuringDocumentGeneration = tenant.shouldReconfigureProductsDuringDocumentGeneration;
          this.shouldUsersDownloadDocumentPrior2012JanuaryRelease = tenant.shouldUsersDownloadDocumentPrior2012JanuaryRelease;
          this.forbidSavingInvalidResponsiveTemplates = tenant.forbidSavingInvalidResponsiveTemplates;
          this.salesTaxBusinessPartnerFunction = tenant.salesTaxBusinessPartnerFunction;
          this.relationshipBusinessPartnerFunction = tenant.relationshipBusinessPartnerFunction;
          this.minimumAllowedPasswordLength = tenant.minimumAllowedPasswordLength;
          this.maximumAllowedPasswordLength = tenant.maximumAllowedPasswordLength;
          this.minimumAllowedNumberOfPasswordsInHistoryToCheck = tenant.minimumAllowedNumberOfPasswordsInHistoryToCheck;
          this.maximumAllowedNumberOfPasswordsInHistoryToCheck = tenant.maximumAllowedNumberOfPasswordsInHistoryToCheck;
          this.useNewDocumentGenerationPage = tenant.useNewDocumentGenerationPage;
          this.isCompanionEnabled = tenant.isCompanionEnabled;
          this.tmpSapCompanionFunctionality = tenant.tmpSapCompanionFunctionality;
          this.arePromotionsEnabled = tenant.arePromotionsEnabled;
          this.isEnabledConfigurationWithoutQuote = tenant.isEnabledConfigurationWithoutQuote;
          this.hideSimpleProductSegregation = tenant.hideSimpleProductSegregation;
          this.useSalesUnitOfMeasure = tenant.useSalesUnitOfMeasure;
          this.tmpAllowAttributeTriggersForVCProducts = tenant.tmpAllowAttributeTriggersForVCProducts;
          this.useScaledPricing = tenant.useScaledPricing;
          this.tmpMigrationToQuote2 = tenant.tmpMigrationToQuote2;
          this.allowGenerateDocumentForMultiSectionTemplate = tenant.allowGenerateDocumentForMultiSectionTemplate;
          this.sourceMigrationTenant = tenant.sourceMigrationTenant;
          this.useUsageBasedPricing = tenant.useUsageBasedPricing;
          this.triggerSaveAction = tenant.triggerSaveAction;
          this.isMultiLicenseConceptEnabled = tenant.isMultiLicenseConceptEnabled;
          this.localAdminCanShowCost = tenant.localAdminCanShowCost;
          this.userCanAttachGenDocOptions = tenant.userCanAttachGenDocOptions;
          this.hideSendMailAfterGenDoc = tenant.hideSendMailAfterGenDoc;
          this.hideEmailFormFromGenDoc = tenant.hideEmailFormFromGenDoc;
          this.hideSendDocumentToOpportunity = tenant.hideSendDocumentToOpportunity;
          this.attachDocumentToCRMWhenSendingEmail = tenant.attachDocumentToCRMWhenSendingEmail;
          this.emailsSentBy = tenant.emailsSentBy;
          this.predefinedEmailClient = tenant.predefinedEmailClient;
          this.predefinedEmailBodyType = tenant.predefinedEmailBodyType;
          this.emailSubject = tenant.emailSubject;
          this.emailBody = tenant.emailBody;
          this.areEmailFromAndNameFieldsDisabled = tenant.areEmailFromAndNameFieldsDisabled;
          this.useMarketFromQuote = tenant.useMarketFromQuote;
          this.showBusinessPartnerSensitiveFields = tenant.showBusinessPartnerSensitiveFields;
          this.doNotPreselectTOOnSendMail = tenant.doNotPreselectTOOnSendMail;
          this.doNotPreselectCcOrBccEmailAddresses = tenant.doNotPreselectCcOrBccEmailAddresses;
          this.defaultCalculationEnabled = tenant.defaultCalculationEnabled;
          this.salesAreaEnabled = tenant.salesAreaEnabled;
          this.salesAreaInMigrationMode = tenant.salesAreaInMigrationMode;
          this.approvalsAutoReminderTestMode = tenant.approvalsAutoReminderTestMode;
          this.isNewReportModuleEnabled = tenant.isNewReportModuleEnabled;
          this.tmpEnableLegacyFederationEndpoints =tenant.tmpEnableLegacyFederationEndpoints;
          this.isQuoteMigrationFeatureEnabled = tenant.isQuoteMigrationFeatureEnabled;
          this.tmpAllowCopyingBackOfficeProducts = tenant.tmpAllowCopyingBackOfficeProducts;
          this.isEuDpEnvironment = tenant.isEuDpEnvironment;
          this.tmpUseOldEventLogPage = tenant.tmpUseOldEventLogPage;
          this.tmpUseGetEventLogsWithTotalCount = tenant.tmpUseGetEventLogsWithTotalCount;
          this.enablePdfCompression = tenant.enablePdfCompression;
          this.imageCompressionType = tenant.imageCompressionType;
          this.imageJpegQuality = tenant.imageJpegQuality;
          this.downsampleImagesResolution = tenant.downsampleImagesResolution;
          this.downsampleImagesResolutionThreshold = tenant.downsampleImagesResolutionThreshold;
          this.productCustomFieldsEnabled = tenant.productCustomFieldsEnabled;
          this.tenantID = tenant.tenantID;
          this.builtInSupportURLPath = tenant.builtInSupportURLPath;
          this.builtInSupportCSSURLPath = tenant.builtInSupportCSSURLPath;
          this.builtInSupportTargetEnvironment = tenant.builtInSupportTargetEnvironment;
          this.tmpSapBuiltInSupportFunctionality = tenant.tmpSapBuiltInSupportFunctionality;
          this.allowedAdditionalFileExtensions = tenant.allowedAdditionalFileExtensions;
          this.tmpDisableQtAttributePlaceholders = tenant.tmpDisableQtAttributePlaceholders;
          this.allowLegacySmtpType = tenant.allowLegacySmtpType;
          this.tmpEnableDkimSha1CertificateGeneration = tenant.tmpEnableDkimSha1CertificateGeneration;
          this.preselectedLanguageFormula = tenant.preselectedLanguageFormula;
          this.tmpIsSolutionOrderDirectIntegrationEnabled = tenant.tmpIsSolutionOrderDirectIntegrationEnabled;
          this.isJouleIntegrationEnabled = tenant.isJouleIntegrationEnabled;
          this.jouleTenantUrl = tenant.jouleTenantUrl;
          this.jouleDigitalAssistantName = tenant.jouleDigitalAssistantName;
        });
  }
}

export enum PricebookAuditTrailStatusOptions {
  Enabled,
  Disabled,
}
